<div class="ai-shell" [ngClass]="'variant-' + (config?.uiVariant || 'inline')">
    <!-- Header -->
    <header class="ai-header">
        <div class="title">
            <mat-icon>auto_awesome</mat-icon>
            <span>{{ config?.title }}</span>
        </div>
        <button *ngIf="config?.showClose" mat-icon-button (click)="closed.emit()">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <!-- Transcript Container (shows intro when no messages, transcript when messages exist) -->
    <div class="transcript-container">
        <!-- Intro (shown when no messages) -->
        <section class="ai-intro"
                 *ngIf="!hasStarted && (config?.startingText || config?.description || (config?.suggestions?.length || 0) > 0)">
            <h2 *ngIf="config?.startingText">{{ config?.startingText }}</h2>
            <p class="muted" *ngIf="config?.description">{{ config?.description }}</p>

		<p class="muted mb-0 mt-4" *ngIf="config?.suggestions?.length && config?.suggestionsTitle">{{ config?.suggestionsTitle }}</p>
      <div class="suggestions" *ngIf="config?.suggestions?.length">
        <button mat-stroked-button class="chip no-padding" *ngFor="let s of config?.suggestions"
                        (click)="handleSuggestionClick(s)">{{ s.label }}</button>
            </div>
        </section>

        <!-- Transcript (shown when messages exist) -->
        <app-ai-transcript-outlet *ngIf="hasStarted" [messages]="displayMessages" [addedIds]="addedIds"
                                  [hidePhotoGridRenderer]="config?.hidePhotoGridRenderer"
                                  (action)="onResultAction($event)"></app-ai-transcript-outlet>

        <!-- Loading Row -->
        <div class="loading-row" *ngIf="isLoading">
            <mat-progress-spinner mode="indeterminate" diameter="16"></mat-progress-spinner>
            <span class="text">{{ config?.loadingText || (config?.mode === 'image' ? DEFAULT_IMAGE_LOADING_TEXT : DEFAULT_COPY_LOADING_TEXT) }}</span>
        </div>
    </div>

	<div class="follow-up-suggestions" *ngIf="hasStarted && !isLoading && config?.followUpSuggestionsTitle && config.followUpSuggestions?.length">
		<p class="muted mb-0 mt-4" *ngIf="config?.followUpSuggestions?.length && config?.followUpSuggestionsTitle">{{ config?.followUpSuggestionsTitle }}</p>
		<div class="suggestions" *ngIf="config?.followUpSuggestions?.length">
			<button mat-stroked-button class="chip no-padding" *ngFor="let s of config?.followUpSuggestions" (click)="handleSuggestionClick(s)">
				{{ s.label }}
			</button>
		</div>
	</div>

    <!-- Context tags + Composer -->
    <section class="ai-composer">

        <!-- Reference Images Grid with Labels (for image-edit and video modes) -->
        <div class="reference-images-grid"
             *ngIf="config?.footer?.showReferenceImages && (config?.mode === 'image-edit' || config?.mode === 'video') && mediaSettings.referenceImages?.length">
            <div *ngFor="let img of mediaSettings.referenceImages; let i = index"
                 class="ref-thumb"
                 [ngClass]="img.referenceType ? 'ref-type-' + img.referenceType : ''">
                <img [src]="img.url" alt="Reference image"/>
                <span class="ref-label" *ngIf="img.referenceType">{{ getReferenceTypeLabel(img.referenceType) }}</span>
                <button (click)="onRemoveReferenceImage(i)" class="ribbon-button remove-btn">
                    <mat-icon inline>close</mat-icon>
                </button>
            </div>
        </div>

        <div class="composer-header">
            <!-- Brand Kit Tags -->
            <span class="tags-list mb-2" *ngIf="config?.brandKit?.tone || config?.copy?.contexts?.length">
			<mat-basic-chip
                    *ngIf="config.brandKit?.tone"
                    disableRipple
                    class="tag-item"
                    color="primary"
            >
				<mat-icon inline>palette</mat-icon>
				<span class="label">{{ config.brandKit?.tone }}</span>
				<mat-icon class="cursor-pointer" inline (click)="onRemoveBradKitOption('tone')">clear</mat-icon>
			</mat-basic-chip>

			<mat-basic-chip
                    *ngIf="config.copy?.contexts?.length"
                    disableRipple
                    class="tag-item" color="primary"
                    [matTooltip]="config.copy.contexts.join(', ')"
            >
				<mat-icon inline>label</mat-icon>
				<span class="label">{{ config.copy.contexts.length }} {{config.copy.contexts.length > 1 ? TRANSLATION_CONTEXT_TAG_PLURAL : TRANSLATION_CONTEXT_TAG_SINGULAR }}</span>
				<mat-icon class="cursor-pointer" inline (click)="onRemoveCopyOption('contexts')">clear</mat-icon>
			</mat-basic-chip>
		</span>
        </div>

        <mat-form-field class="full-width prompt-field no-hint" floatLabel="never">
      <textarea matInput [(ngModel)]="prompt" [placeholder]="config?.composerPlaceholder || 'Type a prompt'"
                cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="6"
                (keydown.enter)="onEnter($event)"></textarea>
        </mat-form-field>

        <!-- Footer Controls - Compact Ribbon -->
        <div class="composer-footer">
            <!-- Parameters button -->
			<button *ngIf="config?.footer?.showSettings && config?.mode === 'copy'"
					class="ribbon-button p-0"
					[tp]="copySettingsTpl"
					[tpMaxWidth]="800"
					[tpClassName]="'conversation-tippy'"
					[tpInteractive]="true"
					[tpTrigger]="'click'"
					[tpAppendTo]="elementRef.nativeElement.parentElement.parentElement.parentElement"
					[tpHideOnClick]="'toggle'"
					[tpZIndex]="999999"
			>
			<mat-icon inline>tune</mat-icon>
            </button>
			<button *ngIf="config?.footer?.showSettings && config?.mode === 'image'"
					class="ribbon-button p-0"
					[tp]="imageSettingsTpl"
					[tpMaxWidth]="800"
					[tpClassName]="'conversation-tippy'"
					[tpInteractive]="true"
					[tpTrigger]="'click'"
					[tpAppendTo]="elementRef.nativeElement.parentElement.parentElement.parentElement"
					[tpHideOnClick]="'toggle'"
					[tpZIndex]="999999"
			>
			<mat-icon inline>tune</mat-icon>
            </button>
			<button *ngIf="config?.footer?.showSettings && config?.mode === 'video'"
					class="ribbon-button p-0"
					[tp]="videoSettingsTpl"
					[tpMaxWidth]="800"
					[tpClassName]="'conversation-tippy'"
					[tpInteractive]="true"
					[tpTrigger]="'click'"
					[tpAppendTo]="elementRef.nativeElement.parentElement.parentElement.parentElement"
					[tpHideOnClick]="'toggle'"
					[tpZIndex]="999999"
			>
			<mat-icon inline>tune</mat-icon>
            </button>
            <!-- Brand Kit button -->
            <button *ngIf="config?.footer?.showBrandKit"
					[tp]="brandKitTpl"
					[tpMaxWidth]="800"
					[tpClassName]="'conversation-tippy'"
					[tpInteractive]="true"
					[tpTrigger]="'click'"
					[tpAppendTo]="elementRef.nativeElement.parentElement.parentElement.parentElement"
					[tpHideOnClick]="'toggle'"
					[tpZIndex]="999999"
					#brandKitTippy="tippy"
                    class="ribbon-button p-0">
                <mat-icon inline>palette</mat-icon>
            </button>
            <!-- Model Selector -->
            <div class="model-selector" *ngIf="config?.footer?.showModelSelector">
                <div class="trigger" [matMenuTriggerFor]="modelMenu">
                    {{ currentModel?.label || config?.defaultModel?.label || 'Select Model' }}
                </div>

                <mat-menu #modelMenu="matMenu" class="tiny">
                    <button mat-menu-item
                            *ngFor="let m of availableModels"
                            (click)="handleModelChange(m)"
                            [class.active]="currentModel?.id === m.id">
                        {{ m.label }}
                    </button>
                    <button mat-menu-item
                            *ngIf="!availableModels?.length && config?.defaultModel"
                            (click)="handleModelChange(config.defaultModel)"
                            [class.active]="currentModel?.id === config.defaultModel.id">
                        {{ config.defaultModel.label }}
                    </button>
                </mat-menu>
            </div>

            <!-- Reference Images Button - shows for image-edit and video modes when enabled -->
            <button
                    *ngIf="config?.footer?.showReferenceImages && (config?.mode === 'image-edit' || config?.mode === 'video')"
                    class="ribbon-button p-2"
                    [matMenuTriggerFor]="refImagesMenu"
                    [disabled]="isLoading">
                <mat-icon inline [matBadge]="mediaSettings.referenceImages?.length || 0"
                          [matBadgeHidden]="!mediaSettings.referenceImages?.length"
                          matBadgeSize="small"
                          matBadgeColor="primary">
                    add_photo_alternate
                </mat-icon>
            </button>
            <mat-menu #refImagesMenu="matMenu" class="tiny">
                <!-- General add option for image-edit mode -->
                <button mat-menu-item
                        *ngIf="config?.mode === 'image-edit'"
                        (click)="onAddReferenceImages()"
                        [disabled]="isMaxReferenceImagesReached()">
                    <mat-icon>add</mat-icon>
                    <span>Add Reference Images ({{ mediaSettings.referenceImages?.length || 0 }}
                        /{{ mediaSettings.maxReferenceImages || 3 }})</span>
                </button>

                <!-- Video mode: typed reference options -->
                <ng-container *ngIf="config?.mode === 'video'">
                    <button mat-menu-item (click)="onAddReferenceImages('style')">
                        <mat-icon>palette</mat-icon>
                        <span>Add Style Reference</span>
                    </button>
                    <button mat-menu-item (click)="onAddReferenceImages('subject')">
                        <mat-icon>person</mat-icon>
                        <span>Add Subject Reference</span>
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item
                            (click)="onAddReferenceImages('first_frame')"
                            [disabled]="hasReferenceOfType('first_frame')">
                        <mat-icon>first_page</mat-icon>
                        <span>Set First Frame</span>
                    </button>
                    <button mat-menu-item
                            (click)="onAddReferenceImages('last_frame')"
                            [disabled]="hasReferenceOfType('last_frame')">
                        <mat-icon>last_page</mat-icon>
                        <span>Set Last Frame</span>
                    </button>
                </ng-container>
            </mat-menu>

            <div class="spacer"></div>

            <!-- Send Button -->
            <button
                    class="ribbon-button send-btn p-2"
                    (click)="handleSend()"
                    [disabled]="!prompt?.trim()">
                <mat-icon inline>arrow_upward</mat-icon>
            </button>
        </div>
    </section>
</div>

<!-- Copy Settings Popover Template -->
<ng-template #copySettingsTpl let-hide>
    <div class="copy-settings">
        <div class="settings-header mb-4 ml-0">
            <div class="title" i18n="Settings Popover Title@@aiConversationShellSettingsTitle">Additional Parameters</div>
			<mat-icon class="cursor-pointer" (click)="hide()">close</mat-icon>
        </div>

        <div class="row two-cols">
			<div>
				<label class="field-label" i18n="Field Label@@aiConversationShellNumberOfVariationsLabel">Number of Variations</label>
				<mat-form-field class="no-top-padding" appearance="fill">
					<input matInput type="number" min="1" [(ngModel)]="copySettings.variations" (ngModelChange)="syncCopyConfig()"/>
				</mat-form-field>
			</div>
			<div>
				<label class="field-label" i18n="Field Label@@aiConversationShellLayerPurposeLabel">Layer Purpose</label>
				<mat-form-field class="no-top-padding" appearance="fill">
					<mat-select [(value)]="copySettings.layerPurpose" (valueChange)="syncCopyConfig()" placeholder="(None)" i18n-placeholder="Field Placeholder@@aiConversationShellLayerPurposePlaceholder">
						<mat-option value="none" i18n="Select Option Label@@aiConversationShellLayerPurposeNoneOption">(None)</mat-option>
						<mat-option value="Headline" i18n-value="Select Option Label@@aiConversationShellLayerPurposeHeadlineOption" i18n="Select Option Label@@aiConversationShellLayerPurposeHeadlineOption">Headline</mat-option>
						<mat-option value="Subheadline" i18n-value="Select Option Label@@aiConversationShellLayerPurposeSubheadlineOption" i18n="Select Option Label@@aiConversationShellLayerPurposeSubheadlineOption">Subheadline</mat-option>
						<mat-option value="Body" i18n-value="Select Option Label@@aiConversationShellLayerPurposeBodyOption" i18n="Select Option Label@@aiConversationShellLayerPurposeBodyOption">Body</mat-option>
						<mat-option value="CTA" i18n-value="Select Option Label@@aiConversationShellLayerPurposeCtaOption" i18n="Select Option Label@@aiConversationShellLayerPurposeCtaOption">CTA</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
        </div>

		<div class="row two-cols">
			<div>
				<label class="field-label" i18n="Field Label@@aiConversationShellMinCharactersLabel">Min. Characters</label>
				<mat-form-field class="no-top-padding" appearance="fill">
					<input matInput type="number" min="0" [(ngModel)]="copySettings.minChars"
						   (ngModelChange)="syncCopyConfig()"/>
				</mat-form-field>
			</div>
			<div>
				<label class="field-label" i18n="Field Label@@aiConversationShellMaxCharactersLabel">Max. Characters</label>
				<mat-form-field class="no-top-padding" appearance="fill">
					<input matInput type="number" min="1" [(ngModel)]="copySettings.maxChars"
						   (ngModelChange)="syncCopyConfig()"/>
				</mat-form-field>
			</div>
		</div>

        <div class="row">
            <label class="field-label" i18n="Field Label@@aiConversationShellCopyContextsLabel">Context (Occasions, moods, etc.)</label>
            <mat-form-field class="full no-top-padding" appearance="fill">
                <mat-chip-list #ctxList>
                    <mat-chip *ngFor="let c of copySettings.contexts; let i = index"
                              (removed)="copySettings.contexts.splice(i,1); syncCopyConfig();" [removable]="true">
                        {{ c }}
                        <button matChipRemove>
                            <mat-icon inline>close</mat-icon>
                        </button>
                    </mat-chip>
					<input matInput [matChipInputFor]="ctxList" placeholder="Add Context..." i18n-placeholder="Input placeholder@@aiConversationShellAddContextPlaceholder" (keydown.enter)="addContext(cInput, $event)" #cInput/>
                </mat-chip-list>
            </mat-form-field>
        </div>

        <div class="row">
            <label class="field-label" i18n="Field Label@@aiConversationShellExamplesLabel">Examples of existing approved copy</label>
            <mat-form-field class="full no-top-padding" appearance="fill">
                <textarea matInput rows="3" placeholder="Enter examples" i18n-placeholder="Input placeholder@@aiConversationShellExamplesPlaceholder" [(ngModel)]="copySettings.examples"
                          (ngModelChange)="syncCopyConfig()"></textarea>
            </mat-form-field>
        </div>

		<div class="row">
			<label class="field-label" i18n="Field Label@@aiConversationShellExcludeKeywordsLabel">Exclude Keywords/Phrases</label>
            <mat-form-field class="full no-top-padding" appearance="fill">
                <textarea matInput rows="2"
						  placeholder="Specify keywords to exclude"
						  i18n-placeholder="Input placeholder@@aiConversationShellExcludeKeywordsPlaceholder"
						  [(ngModel)]="copySettings.exclude"
                          (ngModelChange)="syncCopyConfig()"></textarea>
            </mat-form-field>
        </div>
    </div>
</ng-template>

<!-- Brand Kit Popover Template -->
<ng-template #brandKitTpl let-hide>
    <div class="copy-settings" (click)="$event.stopPropagation()">
		<div class="settings-header mb-4 ml-0">
            <div class="title"
				 i18n="Brand Kit Popover Title@@aiConversationShellBrandKitTitle"
			>Brand Kit</div>
			<mat-icon class="cursor-pointer" (click)="hide()">close</mat-icon>
        </div>

        <div class="row">
			<label class="field-label" i18n="Field Label@@aiConversationShellBrandToneLabel">Brand Tone</label>
            <mat-form-field class="full no-top-padding" appearance="fill">
                <mat-select [(value)]="brandKit.tone" (valueChange)="syncBrandKitConfig()" (click)="$event.stopPropagation()" placeholder="(None)" i18n-placeholder="Field Placeholder@@aiConversationShellBrandTonePlaceholder"
				>
					<mat-option [value]="" i18n="Select Option Label@@aiConversationShellBrandToneNoneOption">(None)</mat-option>
					<mat-option value="Professional" i18n-value="Select Option Label@@aiConversationShellBrandToneProfessionalOption" i18n="Select Option Label@@aiConversationShellBrandToneProfessionalOption">Professional</mat-option>
                    <mat-option value="Friendly" i18n-value="Select Option Label@@aiConversationShellBrandToneFriendlyOption" i18n="Select Option Label@@aiConversationShellBrandToneFriendlyOption">Friendly</mat-option>
                    <mat-option value="Playful" i18n-value="Select Option Label@@aiConversationShellBrandTonePlayfulOption" i18n="Select Option Label@@aiConversationShellBrandTonePlayfulOption">Playful</mat-option>
                    <mat-option value="Bold" i18n-value="Select Option Label@@aiConversationShellBrandToneBoldOption" i18n="Select Option Label@@aiConversationShellBrandToneBoldOption" (click)="$event.stopPropagation()">Bold</mat-option>
                    <mat-option value="Calm" i18n-value="Select Option Label@@aiConversationShellBrandToneCalmOption" i18n="Select Option Label@@aiConversationShellBrandToneCalmOption" (click)="$event.stopPropagation()">Calm</mat-option>
                    <mat-option value="Neutral" i18n-value="Select Option Label@@aiConversationShellBrandToneNeutralOption" i18n="Select Option Label@@aiConversationShellBrandToneNeutralOption">Neutral</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row">
            <label class="field-label" i18n="Field Label@@aiConversationShellKeywordsToUseLabel">Keywords to Use</label>
            <mat-form-field class="full no-top-padding" appearance="fill">
                <textarea matInput
						  rows="2"
						  placeholder="Comma or line separated"
						  i18n-placeholder="Input placeholder@@aiConversationShellKeywordsToUsePlaceholder"
						  [(ngModel)]="brandKit.includeKeywords"
                          (ngModelChange)="syncBrandKitConfig()"
				></textarea>
            </mat-form-field>
        </div>

        <div class="row">
            <label class="field-label" i18n="Field Label@@aiConversationShellKeywordsToNotUseLabel">Keywords to Not Use</label>
            <mat-form-field class="full no-top-padding" appearance="fill">
                <textarea matInput
						  rows="2"
						  placeholder="Comma or line separated"
						  i18n-placeholder="Input placeholder@@aiConversationShellKeywordsToNotUsePlaceholder"
						  [(ngModel)]="brandKit.excludeKeywords"
                          (ngModelChange)="syncBrandKitConfig()"></textarea>
            </mat-form-field>
        </div>

        <div class="row">
            <label class="field-label" i18n="Field Label@@aiConversationShellBrandPurposeLabel">Brand Purpose</label>
            <mat-form-field class="full no-top-padding" appearance="fill">
                <textarea matInput
						  rows="3"
						  i18n-placeholder="Input placeholder@@aiConversationShellBrandPurposePlaceholder"
						  placeholder="What is the brand trying to achieve?"
                          [(ngModel)]="brandKit.purpose" (ngModelChange)="syncBrandKitConfig()"></textarea>
            </mat-form-field>
        </div>
    </div>
</ng-template>

<!-- Image Settings Popover Template -->
<ng-template #imageSettingsTpl  let-hide>
    <div class="copy-settings"  (click)="$event.stopPropagation()">
		<div class="settings-header mb-4 ml-0">
			<div class="title" i18n="Settings Popover Title@@aiConversationShellSettingsTitle">Additional Parameters</div>
			<mat-icon class="cursor-pointer" (click)="hide()">close</mat-icon>
		</div>

        <div class="row two-cols">
			<div>
				<label class="field-label" i18n="Field Label@@aiConversationShellNumberOfResultsLabel">Number of Results</label>
				<mat-form-field class="no-top-padding" appearance="fill">
					<input matInput type="number" min="1" [(ngModel)]="imageSettings.results" (ngModelChange)="syncImageConfig()"/>
				</mat-form-field>
			</div>
			<div>
				<label class="field-label" i18n="Field Label@@aiConversationShellStyleTypeLabel">Style Type</label>
				<mat-form-field class="no-top-padding" appearance="fill">
					<mat-select [(value)]="imageSettings.styleType" (valueChange)="syncImageConfig()" placeholder="Auto" i18n-placeholder="Field Placeholder@@aiConversationShellStyleTypePlaceholder">
						<mat-option value="Auto" i18n="Select Option Label@@aiConversationShellStyleTypeAutoOption">Auto</mat-option>
						<mat-option value="Photo" i18n="Select Option Label@@aiConversationShellStyleTypePhotoOption">Photo</mat-option>
						<mat-option value="Illustration" i18n="Select Option Label@@aiConversationShellStyleTypeIllustrationOption">Illustration</mat-option>
						<mat-option value="3D" i18n="Select Option Label@@aiConversationShellStyleType3DOption">3D</mat-option>
						<mat-option value="Art" i18n="Select Option Label@@aiConversationShellStyleTypeArtOption">Art</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
        </div>

		<div class="row two-cols">
			<div>
				<label class="field-label" i18n="Field Label@@aiConversationShellStepsLabel">Steps</label>
				<mat-form-field class="no-top-padding" appearance="fill">
					<input matInput type="number" min="1" [(ngModel)]="imageSettings.steps" (ngModelChange)="syncImageConfig()"/>
				</mat-form-field>
			</div>
			<div>
				<label class="field-label" i18n="Field Label@@aiConversationShellSeedLabel">Seed</label>
				<mat-form-field class="no-top-padding" appearance="fill">
					<input matInput type="number" min="1" placeholder="Random" i18n-placeholder="Input placeholder@@aiConversationShellSeedPlaceholder"
						   [value]="imageSettings.seed === 'random' ? '' : imageSettings.seed"
						   (blur)="setSeed($event.target['value'])"
						   (ngModelChange)="0"/>
				</mat-form-field>
			</div>
		</div>

		<div class="row two-cols">
			<div>
				<label class="field-label" i18n="Field Label@@aiConversationShellAspectRatioLabel">Aspect Ratio</label>
				<mat-form-field class="no-top-padding" appearance="fill">
					<mat-select [(value)]="imageSettings.aspectRatio" (valueChange)="syncImageConfig()" placeholder="Auto" i18n-placeholder="Field Placeholder@@aiConversationShellAspectRatioPlaceholder">
						<mat-option value="auto" i18n="Select Option Label@@aiConversationShellAspectRatioAutoOption">Auto</mat-option>
						<mat-option value="1:1" i18n="Select Option Label@@aiConversationShellAspectRatioSquareOption">1:1 (Square)</mat-option>
						<mat-option value="16:9" i18n="Select Option Label@@aiConversationShellAspectRatioLandscapeOption">16:9 (Landscape)</mat-option>
						<mat-option value="9:16" i18n="Select Option Label@@aiConversationShellAspectRatioPortraitOption">9:16 (Portrait)</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>

		<div class="row">
			<label class="field-label" i18n="Field Label@@aiConversationShellNegativePromptLabel">Negative Prompt</label>
			<mat-form-field class="full no-top-padding" appearance="fill">
                <textarea matInput rows="3" placeholder="Specify keywords to exclude" i18n-placeholder="Input placeholder@@aiConversationShellNegativePromptPlaceholder"
						  [(ngModel)]="imageSettings.negativePrompt"
						  (ngModelChange)="syncImageConfig()"></textarea>
			</mat-form-field>
		</div>

        <div class="row">
			<mat-checkbox [(ngModel)]="imageSettings.faceEnhancement" (ngModelChange)="syncImageConfig()">
				<span i18n="Checkbox Label@@aiConversationShellFaceEnhancementLabel">Face Enhancement</span>
			</mat-checkbox>
        </div>
    </div>
</ng-template>

<!-- Video Settings Popover Template -->
<ng-template #videoSettingsTpl let-hide>
    <div class="copy-settings" (click)="$event.stopPropagation()">
		<div class="settings-header mb-4 ml-0">
			<div class="title" i18n="Settings Popover Title@@aiConversationShellVideoSettingsTitle">Video Settings</div>
			<mat-icon class="cursor-pointer" (click)="hide()">close</mat-icon>
		</div>

        <div class="row two-cols">
			<div>
				<label class="field-label" i18n="Field Label@@aiConversationShellVideoDurationLabel">Duration (seconds)</label>
				<mat-form-field class="no-top-padding" appearance="fill">
					<mat-select [(value)]="mediaSettings.durationSeconds" (valueChange)="syncMediaConfig()">
						<mat-option [value]="4" i18n="Select Option Label@@aiConversationShellVideoDuration4Option">4 seconds</mat-option>
						<mat-option [value]="5" i18n="Select Option Label@@aiConversationShellVideoDuration5Option">5 seconds</mat-option>
						<mat-option [value]="6" i18n="Select Option Label@@aiConversationShellVideoDuration6Option">6 seconds</mat-option>
						<mat-option [value]="7" i18n="Select Option Label@@aiConversationShellVideoDuration7Option">7 seconds</mat-option>
						<mat-option [value]="8" i18n="Select Option Label@@aiConversationShellVideoDuration8Option">8 seconds</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div>
				<label class="field-label" i18n="Field Label@@aiConversationShellVideoAspectRatioLabel">Aspect Ratio</label>
				<mat-form-field class="no-top-padding" appearance="fill">
					<mat-select [(value)]="mediaSettings.aspectRatio" (valueChange)="syncMediaConfig()">
						<mat-option value="16:9" i18n="Select Option Label@@aiConversationShellVideoAspectRatio16x9Option">16:9 (Landscape)</mat-option>
						<mat-option value="9:16" i18n="Select Option Label@@aiConversationShellVideoAspectRatio9x16Option">9:16 (Portrait)</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
        </div>

		<div class="row two-cols">
			<div>
				<label class="field-label" i18n="Field Label@@aiConversationShellVideoResolutionLabel">Resolution</label>
				<mat-form-field class="no-top-padding" appearance="fill">
					<mat-select [(value)]="mediaSettings.resolution" (valueChange)="syncMediaConfig()">
						<mat-option value="720p" i18n="Select Option Label@@aiConversationShellVideoResolution720pOption">720p</mat-option>
						<mat-option value="1080p" i18n="Select Option Label@@aiConversationShellVideoResolution1080pOption">1080p (HD)</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div>
				<label class="field-label" i18n="Field Label@@aiConversationShellVideoPersonGenerationLabel">Person Generation</label>
				<mat-form-field class="no-top-padding" appearance="fill">
					<mat-select [(value)]="mediaSettings.personGeneration" (valueChange)="syncMediaConfig()">
						<mat-option value="allow_adult" i18n="Select Option Label@@aiConversationShellVideoPersonGenAllowOption">Allow (adults only)</mat-option>
						<mat-option value="dont_allow" i18n="Select Option Label@@aiConversationShellVideoPersonGenDontAllowOption">Don't Allow</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>

		<div class="row">
			<label class="field-label" i18n="Field Label@@aiConversationShellVideoNegativePromptLabel">Negative Prompt</label>
			<mat-form-field class="full no-top-padding" appearance="fill">
                <textarea matInput rows="3" placeholder="Things to avoid in the video" i18n-placeholder="Input placeholder@@aiConversationShellVideoNegativePromptPlaceholder"
						  [(ngModel)]="mediaSettings.negativePrompt"
						  (ngModelChange)="syncMediaConfig()"></textarea>
			</mat-form-field>
		</div>

    </div>
</ng-template>
